// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/images/banner-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 575.98px) {
  #login_modal.modal .modal-dialog {
    margin: 0;
  }
  #login_modal.modal .modal-dialog .modal-content {
    height: 100%;
  }
  #login_modal.modal .register-wrap {
    padding: 0.75rem 1.75rem;
    overflow-y: auto;
  }
  #login_modal.modal .mob-login-header {
    padding: 0.75rem 1.75rem 1rem;
    background-color: var(--gray-85);
    border-bottom: 1px solid var(--gray-80);
  }
  #login_modal.modal .mob-login {
    padding: 0;
  }
  #login_modal.modal .btn-close {
    background-color: transparent;
    border: none;
    top: 1.5rem;
    right: 1rem;
  }
  #login_modal.modal .btn-close svg {
    height: 0.6rem;
    width: 0.6rem;
  }
}
#login_modal.modal .modal-body {
  overflow-x: hidden;
}

.auth-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
}

.auth-form-wrap {
  padding: 24px 10px 24px 24px;
  border: 1px solid #292929;
  border-radius: 15px 0 0 15px;
}
@media screen and (max-width: 991.98px) {
  .auth-form-wrap {
    padding: 24px;
  }
}
@media screen and (max-width: 575.98px) {
  .auth-form-wrap {
    padding: 0;
  }
}
.auth-form-wrap .auth-logo {
  display: flex;
  justify-content: space-between;
}
.auth-form-wrap .auth-logo .license-seal-login {
  width: 40px;
  height: 40px;
}
.auth-form-wrap .auth-logo img {
  width: 100px;
  margin-bottom: 1.5rem;
}
.auth-form-wrap .auth-logo svg {
  margin: 8px auto 32px;
  width: 238px;
  height: 48px;
}
@media screen and (max-width: 575.98px) {
  .auth-form-wrap .auth-logo svg {
    width: 178px;
    height: 36px;
    margin: 4px auto 16px;
  }
}
.auth-form-wrap .auth-logo--betaMobile svg {
  width: 100%;
  height: 97px;
}
.auth-form-wrap .auth-top-btn .nav {
  gap: 0.75rem;
}
.auth-form-wrap .auth-top-btn .nav .nav-item {
  flex: 1 1;
}
.auth-form-wrap .auth-top-btn .nav .nav-item .nav-link {
  background-color: transparent;
  border: 2px solid #5E5E5E;
  border-radius: 0.625rem;
  color: #5E5E5E;
  font-size: 0.875rem;
  font-weight: 500;
  max-height: 40px;
  line-height: 1.75rem;
  padding: 0.3125rem 1.625rem 0.25rem;
  width: 100%;
}
@media screen and (max-width: 575.98px) {
  .auth-form-wrap .auth-top-btn .nav .nav-item .nav-link {
    line-height: 1.5rem;
  }
}
.auth-form-wrap .auth-top-btn .nav .nav-item .nav-link.active, .auth-form-wrap .auth-top-btn .nav .nav-item .nav-link:hover, .auth-form-wrap .auth-top-btn .nav .nav-item .nav-link.active:hover {
  background: linear-gradient(#EFD43C, #CB7D00);
  border: 2px solid #CB7D00;
  color: var(--white);
}
.auth-form-wrap .auth-btn-wrap {
  margin: 0.938rem 0;
}
.auth-form-wrap .auth-btn-wrap .btn {
  height: 44px;
  background: linear-gradient(#EFD43C, #CB7D00);
}
.auth-form-wrap .auth-btn-wrap--betaFilled {
  margin-bottom: 2rem;
}
.auth-form-wrap .auth-social-card {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-form-wrap .auth-social-card a svg {
  width: 5rem;
  height: 100%;
}
@media screen and (max-width: 767.98px) {
  .auth-form-wrap .auth-social-card {
    width: 80px;
  }
  .auth-form-wrap .auth-social-card img {
    width: 100%;
  }
}
.auth-form-wrap form .error-container {
  margin-top: 10px;
  height: 21px;
}
.auth-form-wrap form .error-container p {
  margin: 0;
  font-size: 12px;
}
@media screen and (max-width: 767.98px) {
  .auth-form-wrap form .error-container p {
    font-size: 12px;
  }
}

.register-wrap .forgot-password {
  color: var(--gray-40);
  font-weight: 500;
  font-size: 0.75rem !important;
}

.twofa-wrap p {
  color: var(--gray-40);
  font-weight: 400;
  font-size: 0.875rem !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/login.scss"],"names":[],"mappings":"AAEI;EADF;IAEI,SAAA;EAAJ;EAEE;IAEI,YAAA;EACN;EAGA;IAEI,wBAAA;IACA,gBAAA;EAAJ;EAGA;IAEI,6BAAA;IACA,gCAAA;IACA,uCAAA;EAAJ;EAGA;IAEI,UAAA;EAAJ;EAGA;IAEG,6BAAA;IACA,YAAA;IACA,WAAA;IACA,WAAA;EAAH;EAEI;IACE,cAAA;IACA,aAAA;EAAN;AAlCF;AAsCE;EACE,kBAAA;AADJ;;AAKA;EACE,yDAAA;EACA,wBAAA;EACA,4BAAA;AAFF;;AAMA;EACE,4BAAA;EACA,yBAAA;EACA,4BAAA;AAHF;AAKE;EALF;IAMI,aAAA;EAFF;AACF;AAIE;EATF;IAUI,UAAA;EADF;AACF;AAGE;EAEE,aAAA;EACA,8BAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;AAFN;AAKI;EACE,YAAA;EACA,qBAAA;AAHN;AAMI;EACE,qBAAA;EACA,YAAA;EACA,YAAA;AAJN;AAMM;EALF;IAMI,YAAA;IACA,YAAA;IACA,qBAAA;EAHN;AACF;AAOM;EACE,WAAA;EACA,YAAA;AALR;AAWI;EACE,YAAA;AATN;AAWM;EACE,SAAA;AATR;AAWQ;EACE,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mCAAA;EACA,WAAA;AATV;AAUU;EAXF;IAYI,mBAAA;EAPV;AACF;AASU;EAGE,6CAAA;EACA,yBAAA;EACA,mBAAA;AATZ;AAgBE;EACE,kBAAA;AAdJ;AAgBI;EACE,YAAA;EACA,6CAAA;AAdN;AAiBI;EACE,mBAAA;AAfN;AAmBE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBJ;AAoBM;EACE,WAAA;EACA,YAAA;AAlBR;AAsBI;EAbF;IAcI,WAAA;EAnBJ;EAqBI;IACE,WAAA;EAnBN;AACF;AAwBI;EACE,gBAAA;EACA,YAAA;AAtBN;AAwBM;EACE,SAAA;EACA,eAAA;AAtBR;AAuBQ;EAHF;IAII,eAAA;EApBR;AACF;;AA2BE;EACE,qBAAA;EACA,gBAAA;EACA,6BAAA;AAxBJ;;AA6BE;EACE,qBAAA;EACA,gBAAA;EACA,8BAAA;AA1BJ","sourcesContent":["#login_modal.modal {\n  .modal-dialog {\n    @media screen and (max-width: 575.98px) {\n      margin: 0;\n    }\n    .modal-content {\n      @media screen and (max-width: 575.98px) {\n        height: 100%;\n      }\n    }\n  }\n  .register-wrap {\n    @media screen and (max-width: 575.98px) {\n      padding: 0.75rem 1.75rem;\n      overflow-y: auto;\n    }\n  }\n  .mob-login-header {\n    @media screen and (max-width: 575.98px) {\n      padding: 0.75rem 1.75rem 1rem;\n      background-color: var(--gray-85);\n      border-bottom: 1px solid var(--gray-80);\n    }\n  }\n  .mob-login {\n    @media screen and (max-width: 575.98px) {\n      padding: 0;\n    }\n  }\n  .btn-close {\n    @media screen and (max-width: 575.98px) {\n     background-color: transparent;\n     border: none;\n     top: 1.5rem;\n     right: 1rem;\n\n      svg {\n        height: .6rem;\n        width: .6rem;\n      }\n    }\n  }\n  .modal-body {\n    overflow-x: hidden;\n  }\n}\n\n.auth-img {\n  background-image: url('../../../public/assets/images/banner-bg.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n\n.auth-form-wrap {\n  padding: 24px 10px 24px 24px;\n  border: 1px solid #292929;\n  border-radius: 15px 0 0 15px;\n\n  @media screen and (max-width: 991.98px) {\n    padding: 24px;\n  }\n\n  @media screen and (max-width: 575.98px) {\n    padding: 0;\n  }\n\n  .auth-logo {\n    // text-align: center;\n    display: flex;\n    justify-content: space-between;\n\n    .license-seal-login {\n      width: 40px;\n      height: 40px;\n    }\n\n    img {\n      width: 100px;\n      margin-bottom: 1.5rem;\n    }\n\n    svg {\n      margin: 8px auto 32px;\n      width: 238px;\n      height: 48px;\n\n      @media screen and (max-width: 575.98px) {\n        width: 178px;\n        height: 36px;\n        margin: 4px auto 16px;\n      }\n    }\n\n    &--betaMobile {\n      svg {\n        width: 100%;\n        height: 97px;\n      }\n    }\n  }\n\n  .auth-top-btn {\n    .nav {\n      gap: 0.75rem;\n\n      .nav-item {\n        flex: 1;\n\n        .nav-link {\n          background-color: transparent;\n          border: 2px solid #5E5E5E;\n          border-radius: 0.625rem;\n          color: #5E5E5E;\n          font-size: 0.875rem;\n          font-weight: 500;\n          max-height: 40px;\n          line-height: 1.75rem;\n          padding: 0.3125rem 1.625rem 0.25rem;\n          width: 100%;\n          @media screen and (max-width: 575.98px) {\n            line-height: 1.5rem;\n          }\n\n          &.active,\n          &:hover,\n          &.active:hover {\n            background: linear-gradient(#EFD43C, #CB7D00);\n            border: 2px solid #CB7D00;\n            color: var(--white);\n          }\n        }\n      }\n    }\n  }\n\n  .auth-btn-wrap {\n    margin: 0.938rem 0;\n\n    .btn {\n      height: 44px;\n      background: linear-gradient(#EFD43C, #CB7D00);\n    }\n\n    &--betaFilled {\n      margin-bottom: 2rem;\n    }\n  }\n\n  .auth-social-card {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    a {\n      svg {\n        width: 5rem;\n        height: 100%;\n      }\n    }\n\n    @media screen and (max-width: 767.98px) {\n      width: 80px;\n\n      & img {\n        width: 100%;\n      }\n    }\n  }\n\n  form {\n    .error-container {\n      margin-top: 10px;\n      height: 21px;\n\n      p {\n        margin: 0;\n        font-size: 12px;\n        @media screen and (max-width: 767.98px) {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n}\n\n.register-wrap {\n  .forgot-password {\n    color: var(--gray-40);\n    font-weight: 500;\n    font-size: 0.75rem !important;\n  }\n}\n\n.twofa-wrap {\n  p {\n    color: var(--gray-40);\n    font-weight: 400;\n    font-size: 0.875rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
